import React, { memo, useEffect, useCallback, FC } from 'react'

import { useMutation } from '@apollo/client'
import { useForm } from 'react-hook-form'

import { EMAIL_PATTERN, FORGOT_PASSWORD_CUSTOMER } from 'Const'
import { User } from 'Types'
import { noty } from 'Utils'

import ErrorMessage from 'Components/ErrorMessage'

import FormErrors from '../../FormErrors'

interface Props {
  closeModal(): void
}

const ForgotPasswordModal: FC<Props> = ({ closeModal }) => {
  const { register, handleSubmit, setError, errors } = useForm()

  const [forgotPasswordCustomer, { error }] = useMutation(FORGOT_PASSWORD_CUSTOMER)

  useEffect(() => {
    if (error) {
      error.graphQLErrors.forEach((error) => {
        if (error.extensions?.fieldName) {
          setError(error.extensions.fieldName, { message: error.message })
        }
      })
    }
  }, [error, setError])

  const onSubmit = useCallback(
    async (payload) => {
      void (await forgotPasswordCustomer({ variables: payload }).then(() => {
        noty('You will receive an email with instructions on how to reset your password in a few minutes.', 'success')
        closeModal()
      }))
    },
    [closeModal, forgotPasswordCustomer],
  )

  return (
    <>
      <div className="modal fade show" style={{ display: 'block' }}>
        <div className="modal-dialog modal-dialog-centered">
          <form className="modal-content" onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header align-items-center">
              <h4 className="modal-title">Password Reset</h4>
              <button aria-hidden="true" className="close pull-right" type="button" onClick={closeModal}>
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="form-group row align-items-center">
                <label className="col-sm-2 mb-0" htmlFor="customer-email">
                  Email
                </label>
                <div className="col-sm-10">
                  <input
                    ref={register({
                      required: 'Email is required',
                      pattern: {
                        value: EMAIL_PATTERN,
                        message: 'Email incorrect',
                      },
                    })}
                    required
                    className="form-control mb-0"
                    id="customer-email"
                    name="email"
                    placeholder="Enter your email..."
                    type="email"
                  />
                </div>
              </div>

              <div className="d-flex align-items-center">
                <div className="mb-0">
                  <ErrorMessage as={FormErrors} errors={errors} name="password" />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-accent" type="submit">
                Reset password
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  )
}

export default memo(ForgotPasswordModal)
